module.exports = __webpack_public_path__ + "media/shivaaura1.c92de76b.webm";